export const ANSWER_ROUTE_OPERATION_NAME = 'KnowledgeDiscoveryAnswerRoute';
export const KnowledgeDiscoveryAnswerRouteQuery = `
  query ${ANSWER_ROUTE_OPERATION_NAME}(
    $siteId: String!
    $query: String!
    $locale: String!
    $metadata: KnowledgeDiscoveryMetadata
    $orgId: String
  ) {
    knowledgeDiscovery {
      smartAnswersRoute(
        siteId: $siteId
        query: $query
        locale: $locale
				metadata: $metadata
				orgId: $orgId
      ) {
        __typename
        ... on KnowledgeDiscoverySmartAnswersRoute {
          route
          transformedQuery
        }
        ... on QueryError {
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
